import {Power3} from "gsap";
import {AnimationEffects} from "../components/ShakeEffect";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {FireInTheHole2} from "../FireInTheHole2";
import {gsap, TweenLite} from "gsap";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";

export class FITH2GameView extends PIXI.Container implements StageLayer{
    private _dimmer: PIXI.Sprite;
    constructor() {
        super();
        this.name = "GameView";
        this.init();
    }

    private creatDimmer(): void {
        this._dimmer = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._dimmer.name = "dimmer";
        this._dimmer.tint = 0x000000;
        this._dimmer.alpha = 0.5;
        this._dimmer.visible = false;
    }

    private init() {
        this.pivot.set(360, 360);
        this.position.set(360, 360);
        this.scale.set(1,1);
        this.creatDimmer();
    }

    public onBombExplode(): void {
        AnimationEffects.Shake({
            obj:this,
            duration: 1,
            hertz:120,
            x:3,
            y:3,
            Intensity:5,
            positionCb: () => new PIXI.Point(360,361),
            ease: Power3.easeOut,
            reverseEase:true
        })
    }

    public onNearWin(): void {
        AnimationEffects.Shake({
            obj:this,
            duration: 0.6,
            hertz:160,
            x:0,
            y:4,
            Intensity:4,
            positionCb: () => new PIXI.Point(360,361),
            ease: Power3.easeOut,
            reverseEase:true
        })
    }

    public onResize() {
        FireInTheHole2.background.onResize();
        FireInTheHole2.multiplier.onResize();
        FireInTheHole2.reelFrame.onResize();
        FireInTheHole2.fsLeftView.onResize();
        FireInTheHole2.logo.onResize();
        if(this._dimmer.visible){
            this.resetDimmer();
        }
    }

    private resetDimmer():void{
        const bonds = NolimitApplication.screenBounds
        this._dimmer.width = bonds.width;
        this._dimmer.height = bonds.height;
        this._dimmer.position.x = bonds.left;
        this._dimmer.position.y = bonds.top;
    }

    public addDimmer(aboveCollector:boolean = false, duration:number = 0.2, value:number = 0.7): gsap.core.Timeline {
        return new gsap.core.Timeline().add(() => {
            if(aboveCollector){
                FireInTheHole2.fullScreenDimmer.addChild(this._dimmer);
            }else{
                FireInTheHole2.emptyLayerBelowCollector.addChild(this._dimmer);
            }
            this.resetDimmer();
            this._dimmer.alpha = 0;
            this._dimmer.visible = true;
        }).add(TweenLite.to(this._dimmer, duration, {alpha: value}));
    }

    public removeDimmer(): gsap.core.Timeline {
        return new gsap.core.Timeline().to(this._dimmer, 0.2, {alpha: 0}).add(() => {
            if(this._dimmer.parent){
                this._dimmer.parent.removeChild(this._dimmer);
            }
            this._dimmer.visible = false;
        });
    }

    public scaleUp(): gsap.core.Timeline {
        const animation: gsap.core.Timeline = new gsap.core.Timeline();
        animation.add(() => {
            this.scale.set(1.4, 1.4);
            this.alpha = 0;
            FireInTheHole2.setMode(FireInTheHole2.model.data.nextMode);
        });
        animation.add([
            gsap.to(this.scale, 1.5, {x: 1, y: 1}),
            gsap.to(this, 0.2, {alpha: 1}),
        ]);

        return animation;
    }

}